import { createAsyncThunk } from "@reduxjs/toolkit";
import { forgotPasswordApi } from "./api";

export const forgotPassword = createAsyncThunk(
	"forgotPassword",
	async (payload) => {
		try {
			const res = await forgotPasswordApi(payload);
			return res.data;
		} catch (err) {
			throw err.response.data;
		}
	},
);
